import { useQuery } from '@tanstack/react-query';
import { getApplicationAssets } from '@/api/Rover/ApplicationAssets';
import { getApplicationEvents } from '@/api/Rover/ApplicationEvents';
import { getApplicationTeamMembers } from '@/api/Rover/applicationTeam';
import { RoverReactQueryKey } from '@/constants/ReactQueryKeys';
import type { QueryParamsInterface } from '@/types/Shared';

interface ApplicationTeamMembersHookProps {
  applicationId: string | undefined;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}

export const useApplicationTeamMembers = ({ applicationId, onSuccess, onError }: ApplicationTeamMembersHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [RoverReactQueryKey.GET_APPLICATIONS_TEAM_MEMBERS, applicationId],
    queryFn: () => getApplicationTeamMembers({ applicationId }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};

interface IApplicationAssetsHookProps {
  applicationId: string;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}

export const useApplicationAssets = ({ applicationId, params, onSuccess, onError }: IApplicationAssetsHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [RoverReactQueryKey.GET_APPLICATION_ASSETS, { params, applicationId }],
    queryFn: () => getApplicationAssets({ applicationId, params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};

interface IApplicationEventsHookProps {
  applicationId: string;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}

export const useApplicationEvents = ({ applicationId, params, onSuccess, onError }: IApplicationEventsHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [RoverReactQueryKey.GET_APPLICATION_EVENTS, { params, applicationId }],
    queryFn: () => getApplicationEvents({ applicationId, params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
